export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE = 0;
export const NO_SELECTION = -1;
export const ROWS_PER_PAGE_OPTIONS = [15, 25, 50];
